import {
  CreateCustomerAddressDto,
  CustomerAddress,
  UpdateCustomerAddressDto,
} from '@interfaces/address.interface';

import api from './';

export const {
  useGetCustomerAddressesQuery,
  useCreateCustomerAddressMutation,
  useUpdateCustomerAddressMutation,
  useDeleteCustomerAddressMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerAddresses: builder.query<CustomerAddress[], void>({
      query: () => ({
        url: '/customer-addresses',
      }),
      providesTags: ['customer-addresses'],
    }),
    createCustomerAddress: builder.mutation<
      CustomerAddress,
      CreateCustomerAddressDto
    >({
      query: (body) => ({
        url: '/customer-addresses',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['customer-addresses'],
    }),
    updateCustomerAddress: builder.mutation<
      CustomerAddress,
      UpdateCustomerAddressDto
    >({
      query: ({ id, body }) => ({
        url: `/customer-addresses/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['customer-addresses'],
    }),
    deleteCustomerAddress: builder.mutation<CustomerAddress, number>({
      query: (id) => ({
        url: `/customer-addresses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['customer-addresses'],
    }),
  }),
});
